// extracted by mini-css-extract-plugin
module.exports = {"container":"sidebar-list_container__5omZ1","list-header":"sidebar-list_list-header__2wl_p","title":"sidebar-list_title__161sT","label":"sidebar-list_label__7EN-m"};